var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UploadLi',_vm._b({attrs:{"icon":_vm.pcImg,"nameText":"电脑上传","nameTip":"需要电脑、税盘"},on:{"upload":_vm.upload}},'UploadLi',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }